import React from "react";


const CartCard = (props) => {
    const { idNo } = props;
    const { count } = props;
    const {AllProducts} =props

    const product = AllProducts.filter((p)=> p.id==idNo);
    
    const {decrementCount}=props;
    const {incrementCount}=props;


    return (
        <div className="overflow-x-hidden">
            {/* Item-1 */}
            <div className=' shadow-violet-300  bg-white w-full flex justify-between md:h-[165px] h-[60px] border-[3px] border-violet-600 md:rounded-xl rounded-lg overflow-hidden shadow-md'>

                {/* Col 1 */}
                <div className='md:ml-5 ml-2 mr-2  md:w-[150px] md:h-[150px] w-[50px] h-[50px] flex justify-center items-center'>
                    <img src={product[0].image} className='h-full object-contain' />
                </div>

                {/* Col-2 */}
                <div className='md:w-[350px] w-[150px] h-full  flex justify-center items-center p-2 '>
                    <h2 className='text-center w-full md:text-xl md:leading-6 text-xs leading-1 font-bold  overflow-text-3'>{product[0].title}</h2>
                </div>

                {/* col-3 */}
                <div className='md:w-[200px] w-[120px]  h-full flex justify-center items-center md:p-3 p-1 '>
                    <h1 className='md:text-3xl w-full text-sm text-green-700 font-bold'>₹ {product[0].price}</h1>
                </div>

                {/* col-4 */}
                <div className='md:w-[250px] w-[100px] h-full flex justify-center md:gap-8 gap-3 items-center md:p-3 p-1 '>

                    <div className='select-none md:border-[2px] border-black flex md:rounded-xl rounded-md overflow-hidden  items-center'>
                        
                        <button onClick={() => {decrementCount(idNo)}} className='md:p-5 p-1 bg-red-600 md:h-[30px]  w-[20px] md:w-[50px] flex justify-center content-center items-center md:border-r-[3px] border-black hover:bg-red-800 active:text-white md:text-4xl text-xl h-[20px] select-none'><span className=' select-none'>  - </span></button>
                        <span className=' md:text-4xl text-lg md:mx-5 mx-2 text-center '> {count} </span>
                        <button onClick={()=>{incrementCount(idNo)}}><span className='md:text-4xl text-xl md:p-5 p-1 bg-green-700 md:w-[50px] md:h-[30px] h-[20px] flex justify-center content-center  md:border-l-[3px] border-black items-center hover:bg-green-800 active:text-white select-none'> + </span></button>

                    </div>

                </div>


                {/* Col-5 TOTAL PRICE*/}

                <div className=' md:w-[200px] w-[200px] h-full flex justify-center items-center md:p-3 p-1 '>
                    <h1 className='md:text-4xl text-center flex text-sm text-green-700 font-bold'>₹ {(product[0].price * count).toFixed(2)}</h1>
                </div>

            </div>
        </div>
    );
};

export default CartCard;